import { ComponentPropsWithoutRef, FC, ReactNode } from 'react';
import { Checkbox, Radio } from 'react-daisyui';
import { cn } from '@/utils/classNames.ts';

export type CheckboxInputProps = ComponentPropsWithoutRef<typeof Checkbox> & {
  label?: ReactNode;
  error?: string;
  wrapperClassName?: string;
  type?: 'checkbox' | 'radio';
};

const CheckboxInput: FC<CheckboxInputProps> = ({ wrapperClassName, label, error, type = 'checkbox', ...args }) => {
  return (
    <label className={cn('label cursor-pointer justify-start gap-2', wrapperClassName)}>
      {type === 'checkbox' ? <Checkbox {...args} /> : <Radio {...args} />}
      <span
        className={cn('label-text', {
          'text-error': !!error,
        })}
      >
        {label}
      </span>
    </label>
  );
};

export default CheckboxInput;
